/** Identifiants des actions possibles sur les notifications locales de rappel */
export enum EReminderAlarmAction {
	reschedule = "reschedule",
	repeatAfter5mn = "repeatAfter5mn",
	repeatAfter15mn = "repeatAfter15mn"
}
